import Credit from "../../../../Entities/Credit";
import InvoiceLineItem from "../../../../Entities/InvoiceLineItem";
import Validation from "../../../../Entities/Validation";
import Payment, { allowedManualPaymentTypes, PaymentEntryInput } from "../../../../Entities/Payment";
import { queryGetCreditsForInvoicePayment } from "../../../../Queries";

import featureFlags from '../../../../featureFlags';

const creditQueryFields = [
  'id',
  'readable_id',
  'amount',
  'balance',
  'application_type',
  'created_at',
  {
    'payment_meta': [
      'check_number'
    ]
  },
  {
    'subscription': [
      {
        'payor': [
          'readable_id',
          'billing_firstname',
          'billing_lastname'
        ]
      },
      {
        'billing_profile': [
          'facility_id'
        ]
      }
    ]
  },
  {
    'credit_entries': [
      'id',
      'type',
      'amount',
      'amount_tax_1',
      'amount_tax_2',
      'amount_tax_3',
      'amount_tax_4',
      'application_date',
      'created_at'
    ]
  }
];

class InvoicePaymentPanelConfig {
  initialState = {}
  fieldConfiguration = {}
  invoice = null;
  credits = []

  constructor({ invoice }) {
    this.invoice = invoice;
  }

  loadConfig = async () => {
    const initializationTasks = [
      this.getPaymentAllocationTypes(),
      featureFlags.OVERPAYMENT_PT2_I ? this.getCreditApplicationTypes() : null,
      this.getLineItemTitleOptions(),
      this.fetchCredits()
    ];

    const payment = new Payment();
    const paymentEntries = this.invoice.fields.line_items.value.reduce((paymentEntries, lineItem) => {
      const paymentEntry = new PaymentEntryInput();
      paymentEntry.fields.line_item_id.value = lineItem.fields.id.value;
      return {
        ...paymentEntries,
        [lineItem.fields.id.value]: paymentEntry
      }
    }, {});

    this.initialState = {
      payment,
      paymentEntries
    }

    await Promise.all(initializationTasks);
    return this;
  }

  fetchCredits = async () => {
    const invoiceId = this.invoice.fields.id.value;
    const response = await queryGetCreditsForInvoicePayment({ invoiceId }, creditQueryFields);
    if (response.errors) {
      throw response.errors.map(error => error.message);
    }

    const credits = response.data.getCreditsForInvoicePayment.map(credit => Credit.createFromQueryValues(credit))

    this.credits = credits;
    const credit_id = {
      options: [
        { value: null, label: '' },
        ...credits.map((credit) => ({
          value: credit.fields.id.value,
          label: `${credit.fields.readable_id.value} - $${credit.fields.balance.value / 100}`
        })),
      ]
    };

    this.fieldConfiguration = {
      ...this.fieldConfiguration,
      credit_id
    }
  }

  getPaymentAllocationTypes = async () => {
    const data = await Payment.getPaymentAllocationTypes();

    this.fieldConfiguration.allocation = {
      options: [
        { value: null, label: '' },
        ...data.allocation.options
      ]
    };
  }

  getCreditApplicationTypes = async () => {
    const selectableTypes = await Credit.getSelectableApplicationTypes();
    this.fieldConfiguration.application_type = { options: selectableTypes };
  }

  getLineItemTitleOptions = async () => {
    const lineItemRateTypeEnum = await InvoiceLineItem.getFieldAllowedValues(['line_item_rate_type']);
    const validationTypeEnum = await Validation.getFieldAllowedValues(['type']);

    this.fieldConfiguration.line_item_title = {
      options: [
        ...lineItemRateTypeEnum.line_item_rate_type.options,
        ...validationTypeEnum.type.options,
      ]
    };
  }
}

export default InvoicePaymentPanelConfig;